import React from "react";
import { PageWrapperDark } from "../components/page-wrapper";
import Button from "@material-ui/core/Button";
import emailjs from "emailjs-com";
import { useForm } from "react-hook-form";
import "../styles/pages/contact.scss";

function Contact() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  async function sendEmail(e) {
    try {
      await emailjs.sendForm(
        "service_2z0wxnp",
        "template_jzekx58",
        e.target,
        "DPfrSU_y7vESqvHwp",
      );
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <PageWrapperDark>
      <main>
        <div id="contact-section" className="container">
          <h1>
            Get in touch<span>.</span>
          </h1>
          <div id="contact-content">
            <form
              id="contact-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(() => sendEmail(e))();
              }}
            >
              <input
                type="text"
                name="name"
                placeholder="name"
                {...register("name", { required: true })}
              />
              {errors.name && (
                <span class="error">Don't forget your name!</span>
              )}
              <input
                type="text"
                name="email"
                placeholder="email"
                {...register("email", { required: true })}
              />
              {errors.email && (
                <span class="error">Don't forget your email!</span>
              )}
              <textarea
                name="message"
                {...register("message", { required: true })}
                id="message"
                rows="10"
              />
              {errors.message && (
                <span class="error">Don't forget your Message!</span>
              )}
              <Button id="submit" type="submit">
                Send
              </Button>
            </form>
            <div id="banner">
              <section>
                <h2>Contact</h2>
                <p style={{ color: "white" }}>p: (657)-216-2066</p>
                <p style={{ color: "white" }}>e: josec@westcoast-metalroofing.com</p>
              </section>
              <section>
                <p style={{ color: "white" }}>630 Jefferson St. Suite E</p>
                <p style={{ color: "white" }}>Placentia CA 92870</p>
              </section>
            </div>
          </div>
        </div>
      </main>
    </PageWrapperDark>
  );
}

export default Contact;
